import { EntityData } from "@/components/TriggerSetup/logic/types/entity-data.type";
import { baseCondition } from "@/components/TriggerSetup/logic/structures/base-condition.structure";
import { TriggerCondition } from "@/components/TriggerSetup/logic/types/types";
import { snakeCase } from "lodash";
import { getTagsByFieldKey } from '@/mixins/TariffsTagsHelper'
import i18n from '@/i18n/i18n'
import MessageTextMentionEntityRegexpTypeSetupView
  from '@/components/TriggerSetup/conditions/MessageTextMentionEntityRegexpType/MessageTextMentionEntityRegexpTypeSetupView.vue'

const condition: () => EntityData = () => {
  return {
    'setupView': MessageTextMentionEntityRegexpTypeSetupView,
    'structure': {
      'type': 'MessageTextMentionEntityRegexpType',
      ...baseCondition,
    } as TriggerCondition,
    'titleKey': `trigger_condition_${ snakeCase('MessageTextMentionEntityRegexpType') }`,
    'limited': getTagsByFieldKey('MessageTextMentionEntityRegexpTypeCondition'),
    'helpMessage': i18n.t('regexp_condition_help_message').toString()
  }
}

export default condition
